import React, { useEffect, useState } from "react";
import Joyride from "react-joyride";
import { Button, Modal } from "antd";
import { useTour } from "./useTour";
import { useLocation, useNavigate } from "react-router-dom";
import TourConfirmationModal from "./TourConfirmationModal";
import { getUserRole } from "../service";

const SidebarTour = () => {
  const {
    showTour,
    startAiTour,
    stepIndex,
    isBottomTour,
    isKnowledgeBaseTour,
    setIsKnowledgeBaseTour,
    setStepIndex,
    setShowTour,
    handleTourEnd,
    startBottomNavTour,
    startKnowledgeBaseTour,
    sidebarSteps,
    bottomNavSteps,
    adminBottomNavSteps,
    knowledgeBaseSteps,
    setIsBottomTour,
    setIsModalVisible,
    chooseAiSteps,
    isDropdownOpen,
    setIsDropdownOpen,
    startTour,
    isWelcomeModalVisible,
    setIsWelcomeModalVisible,
    isTourConfirmationVisible,
    setIsTourConfirmationVisible,
    isCompletionModalVisible,
    setIsCompletionModalVisible,
    isAiTour,
    setIsAiTour,
    tourCompleted,
    setTourCompleted,
    startSidebarTour,
    userBottomNavSteps
  } = useTour();

  const [isKnowledgeBaseModalVisible, setIsKnowledgeBaseModalVisible] = useState(false);
  const [pauseTour, setPauseTour] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const userRole = getUserRole();

  useEffect(() => {
    sidebarSteps.forEach((step, idx) => {
    });
  }, [showTour, isAiTour, isKnowledgeBaseTour, isBottomTour, stepIndex, tourCompleted, sidebarSteps, location.pathname]);

  const endTourWithCompletion = () => {
    setShowTour(false);
    setIsTourConfirmationVisible(false);
    setIsCompletionModalVisible(true);
    handleTourEnd(true); 
  };

  return (
    <>
      <Modal
        title="👋 Welcome to the Site Tour!"
        visible={isWelcomeModalVisible}
        style={{
          marginTop: "35px"
        }}
        onOk={() => {
          setIsWelcomeModalVisible(false);
          startAiTour();
        }}
        onCancel={() => {
          setIsWelcomeModalVisible(false);
          endTourWithCompletion();
        }}
        okText="Start Tour"
        cancelText="Skip"
      >
        <p>This quick tour will help you navigate the platform and discover key features. Click "Start Tour" to begin or "Skip" to explore on your own.</p>
      </Modal>

      <Joyride
        key={isKnowledgeBaseTour ? "knowledgeBaseTour" : isBottomTour ? "bottomNavTour" : "sidebarTour"}
        steps={
          chooseAiSteps.length > 0
            ? chooseAiSteps
            : isKnowledgeBaseTour
              ? knowledgeBaseSteps
              : isBottomTour
                ? userRole === "admin"
                  ? adminBottomNavSteps
                  : userRole === "user"
                    ? userBottomNavSteps
                    : bottomNavSteps
                : sidebarSteps
        }
        stepIndex={stepIndex}
        run={showTour && !pauseTour && !isWelcomeModalVisible && !isCompletionModalVisible}
        continuous
        showProgress
        showSkipButton
        disableBeacon
        disableOverlayClose={true}
        disableCloseOnEsc={true}
        scrollToFirstStep={false}
        spotlightPadding={0}
        styles={{
          options: {
            primaryColor: "#23418F",
            zIndex: "9999",
          },
          buttonBack: {
            display: "none",
          },
        }}
        floaterProps={{
          disableScrolling: true,
        }}
        callback={(data) => {
          const { action, status, index, type, step } = data;
          if (type === "step:before" && step.target === "#bot-option-deepseek") {
            const deepSeekOption = document.querySelector("#bot-option-deepseek");
            if (deepSeekOption) {
              deepSeekOption.scrollIntoView({ behavior: "smooth", block: "center" });
              console.log("DeepSeek position:", deepSeekOption.getBoundingClientRect());
              if (!deepSeekOption.offsetParent) {
                setIsDropdownOpen(true);
                setTimeout(() => {
                  deepSeekOption.scrollIntoView({ behavior: "smooth", block: "center" });
                }, 200); 
              }
            } else {
              console.log("DeepSeek target not found, retrying...");
              setTimeout(() => {
                const retryElement = document.querySelector("#bot-option-deepseek");
                if (retryElement) {
                  retryElement.scrollIntoView({ behavior: "smooth", block: "center" });
                  setIsDropdownOpen(true); 
                }
              }, 200);
            }
          }
        
          if (type === "step:before" && step.target === "#choose-ai-dropdown") {
            setIsDropdownOpen(true); 
          }
          if (index === 0 && action === "next" && step.target === "#explore-agents-btn") {
            setTimeout(() => {
              navigate("/public-agent");
            }, 100);
          }

          if (type === "step:after" && isKnowledgeBaseTour && index === knowledgeBaseSteps.length - 1 && action === "next") {
            setTimeout(() => {
              setStepIndex(0);
              setShowTour(false);
              setIsKnowledgeBaseTour(false);
              setIsAiTour(false);
              setIsBottomTour(false);
              startSidebarTour();
            }, 500);
            return;
          }

          if (type === "step:after" && index === chooseAiSteps.length - 1 && action === "next") {
            setTimeout(() => {
              setStepIndex(0);
              setShowTour(false);
              chooseAiSteps.length = 0;
              setIsKnowledgeBaseModalVisible(true);
              setPauseTour(true);
              setTimeout(() => {
                setShowTour(true);
              }, 500);
            }, 500);
            return;
          }

          if (isKnowledgeBaseTour && index === 0 && action === "next" && location.pathname !== "/knowledge-base") {
            setTimeout(() => {
              navigate("/knowledge-base");
            }, 500);
            return;
          }

          if (isKnowledgeBaseTour && index === 1 && action === "next") {
            setStepIndex((prev) => prev + 1);
            return;
          }

          if (isKnowledgeBaseTour && location.pathname === "/knowledge-base" && index === 0) {
            setStepIndex((prev) => prev + 1);
            return;
          }

          if (type === "step:after" && action === "next") {
            const activeSteps = chooseAiSteps.length > 0
              ? chooseAiSteps
              : isKnowledgeBaseTour
                ? knowledgeBaseSteps
                : isBottomTour
                  ? userRole === "admin"
                    ? adminBottomNavSteps
                    : userRole === "user"
                      ? userBottomNavSteps
                      : bottomNavSteps
                  : sidebarSteps;

            const nextStep = activeSteps[stepIndex + 1];

            if (nextStep) {
              const checkElementExists = () => {
                const element = document.querySelector(nextStep.target);
                if (element) {
                  setStepIndex((prev) => prev + 1);
                } else {
                  setTimeout(checkElementExists, 500);
                }
              };
              checkElementExists();
            } else {
              setStepIndex((prev) => prev + 1);
            }
          }

          if (status === "finished" || status === "skipped") {
            setIsDropdownOpen(null);

            const proceedToNextTour = () => {
              if (chooseAiSteps.length > 0) {
                setStepIndex(0);
                setShowTour(false);
                chooseAiSteps.length = 0;
                setIsKnowledgeBaseTour(true);
                setTimeout(() => setShowTour(true), 500);
              } else if (isKnowledgeBaseTour) {
                setStepIndex(0);
                setShowTour(false);
                setIsKnowledgeBaseTour(false);
                setIsAiTour(false);
                setIsBottomTour(false);
                setTimeout(() => {
                  startSidebarTour();
                }, 500);
              } else if (isBottomTour && bottomNavSteps.length > 0) {
                endTourWithCompletion();
              } else if (sidebarSteps.length > 0) {
                setStepIndex(0);
                setShowTour(false);
                if (!isTourConfirmationVisible) {
                  setIsTourConfirmationVisible(true);
                }
              } else {
                endTourWithCompletion();
              }
            };

            proceedToNextTour();
          }

          if (action === "prev") {
            setStepIndex((prev) => {
              const newIndex = prev - 1;
              return newIndex >= 0 ? newIndex : 0;
            });
          }

          if (index === 0 && action === "next" && isBottomTour) {
            setTimeout(() => {
              document.querySelector(".user-btn")?.click();
            }, 500);
          }

          if (index === 0 && action === "next") {
            setTimeout(() => {
              setIsDropdownOpen(true);
            }, 500);
          }
        }}
      />

      <Modal
        title="Have you personalized your Knowledge Base?"
        visible={isKnowledgeBaseModalVisible}
        onOk={() => {
          setIsKnowledgeBaseModalVisible(false);
          setPauseTour(false);
          startKnowledgeBaseTour();
        }}
        style={{
          marginTop: "40px"
        }}
        onCancel={() => {
          setIsKnowledgeBaseModalVisible(false);
          endTourWithCompletion();
        }}
        okText="Yes, Continue"
        cancelText="No, Exit"
      >
        <p>Before continuing the tour, we recommend personalizing your Knowledge Base for the best experience.</p>
      </Modal>

      <Modal
        title="🎉 Hurray! You've Completed the Site Tour!"
        visible={isCompletionModalVisible}
        onOk={() => {
          setIsCompletionModalVisible(false);
          setShowTour(false);
          handleTourEnd(false); 
        }}
        onCancel={() => {
          setIsCompletionModalVisible(false);
          handleTourEnd(false); 
        }}
        style={{
          zIndex: "9999",
          marginTop: "35px"
        }}
        footer={[
          <Button key="manual" type="primary" onClick={() => window.open("https://docs.google.com/document/d/1OymagfURkYKQ-cEiCOlsf_jekQhmZ6tQuhQtrvu3-d4/edit?tab=t.0#heading=h.liw6lsrnj45q", "_blank")}>
            📖 Open User Manual
          </Button>,
          <Button
            key="close"
            onClick={() => {
              setIsCompletionModalVisible(false);
              setShowTour(false);
              handleTourEnd(false); 
            }}
          >
            Close
          </Button>,
        ]}
      >
        <p>If you still have any doubts, check out our User Manual for detailed guidance.</p>
      </Modal>

      <TourConfirmationModal
        isOpen={isTourConfirmationVisible}
        onClose={() => {
          endTourWithCompletion();
        }}
        onConfirm={() => {
          setIsTourConfirmationVisible(false);
          startBottomNavTour();
        }}
      />
    </>
  );
};

export default SidebarTour;